module.exports = __webpack_public_path__ + "img/阿尼亚.f65559a8.jpg";